import clsx from "clsx";
import React from "react";
import { Button } from "./button";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

export function ParentPagination({
  "aria-label": ariaLabel = "Page navigation",
  className,
  ...props
}: React.ComponentPropsWithoutRef<"nav">) {
  return (
    <nav
      aria-label={ariaLabel}
      {...props}
      className={clsx(className, "flex gap-x-2")}
    />
  );
}

export function PaginationPrevious({
  href = null,
  children = "Previous",
}: {
  href?: string | null;
  children?: React.ReactNode;
}) {
  return (
    <span className="grow basis-0">
      <Button
        {...(href === null ? { disabled: true } : { href })}
        plain
        aria-label="Previous page"
        className="!px-0 lg:!px-4">
        <ChevronLeftIcon className="h-4 w-4" />
        {children}
      </Button>
    </span>
  );
}

export function PaginationNext({
  href = null,
  children = "Next",
}: {
  href?: string | null;
  children?: React.ReactNode;
}) {
  return (
    <span className="flex grow basis-0 justify-end">
      <Button
        {...(href === null ? { disabled: true } : { href })}
        plain
        aria-label="Next page"
        className="!px-0 lg:!pl-2">
        {children}
        <ChevronRightIcon className="h-4 w-4" />
      </Button>
    </span>
  );
}

export function PaginationList({ children }: { children: React.ReactNode }) {
  return (
    <span className="hidden items-baseline gap-x-2 sm:flex">{children}</span>
  );
}

export function PaginationPage({
  href,
  children,
  current = false,
}: {
  href: string;
  children: string;
  current?: boolean;
}) {
  return (
    <Button
      href={href}
      plain
      aria-label={`Page ${children}`}
      aria-current={current ? "page" : undefined}
      className={clsx(
        "min-w-[2.25rem] before:absolute before:-inset-px before:rounded-lg",
        current && "before:bg-zinc-950/5 dark:before:bg-white/10",
      )}>
      <span className="-mx-0.5">{children}</span>
    </Button>
  );
}

export function PaginationGap() {
  return (
    <div
      aria-hidden="true"
      className="w-[2.25rem] select-none text-center text-sm/6 font-semibold text-zinc-950 dark:text-white">
      &hellip;
    </div>
  );
}
